import { render, staticRenderFns } from "./EventsPerPerson.vue?vue&type=template&id=6355a18d&scoped=true&"
import script from "./EventsPerPerson.vue?vue&type=script&lang=ts&"
export * from "./EventsPerPerson.vue?vue&type=script&lang=ts&"
import style0 from "./EventsPerPerson.vue?vue&type=style&index=0&id=6355a18d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6355a18d",
  null
  
)

export default component.exports